import React from "react";
import "./Common.css";
import "../Components/BreadCrumb.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

import Header from "../Components/Header";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";

export default function TermsConditions() {
   return (
    <div className="t_p_page">
      <Header mode="dark" />

      <div className="breadCrumb_main">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="breadcrumb_title">
                <Breadcrumb>
                  <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Terms & Conditions</Breadcrumb.Item>
                </Breadcrumb>
                <h1>Terms & Conditions</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="privacy_terms_desc">
        <div className="container">
          <div className="content_start">
            <p>
              At Textile, we value your privacy and are committed to protecting
              your personal information. This Privacy Policy explains how we
              collect, use, and safeguard your data when you visit our website.
            </p>
            <h3>1. Information We Collect</h3>
            <p>
              We may collect personal details such as your name, email address,
              phone number, shipping address, and payment information when you
              place an order or sign up on our website.
            </p>

            <h3>2. How We Use Your Information</h3>
            <p>Your information is used to:</p>
            <ul>
              <li>Process and deliver your orders</li>
              <li>Communicate order updates</li>
              <li>Improve our website and services</li>
              <li>Send promotional offers (only if you opt-in)</li>
            </ul>

            <h3>3. Data Protection</h3>
            <p>
              We implement appropriate security measures to protect your
              personal data from unauthorized access, misuse, or disclosure.
            </p>

            <h3>4. Sharing of Information</h3>
            <p>
              We do not sell or rent your personal information. We may share it
              with trusted third-party services (like payment gateways and
              delivery partners) only to fulfill your orders.
            </p>

            <h3>5. Cookies</h3>
            <p>
              Our website uses cookies to enhance your browsing experience and
              analyze site traffic.
            </p>

            <h3>6. Your Rights</h3>
            <p>
              You can request access, correction, or deletion of your personal
              data by contacting us.
            </p>

            <h3>7. Changes to This Policy</h3>
            <p>
              We may update this policy from time to time. Changes will be
              posted on this page.
            </p>
          </div>
        </div>
      </div>

      <Feature />
      <Footer />
    </div>
  );
}
